import React, { useState } from "react";

import "./StringTable.css"
import "/src/assets/css/polices.css";

const StringTable = ({ data}) => {

    const [isOpen, setOpen] = useState((false));

    const openListData = () => {
        setOpen(!isOpen);
    }
    let lastElement = data != null ? data[data.length - 1] : null
    const length = data != null && lastElement ? data.length : 0;

    const nbLetter = 35
    return (
        <div className="data_container" onClick={() => openListData()}>
            {isOpen == false ?
                <span className="string_table_documents">  {data != null && lastElement ? (lastElement.length > nbLetter ? (lastElement.substring(0, nbLetter) +"..." ) : lastElement) : ""}
                    <span style={{ color: "var(--main)  ", fontWeight: "bold" }}> {length > 1 ? (`(+ ${length - 1})`)  :"" }
                    </span>
                </span>
                :
                <span style={{ textAlign : 'left' }}> {data?.map(elem => elem).reduce((prev, curr) => [prev, <br />, curr])} </span>
            }
        </div>
    )
};

export default StringTable;